var map = {
	"./IPR-en.PNG": 586,
	"./IPR-ru.PNG": 587,
	"./Rectangle 7.jpg": 597,
	"./arrow-down.svg": 598,
	"./auth-img.jpg": 593,
	"./bell.svg": 599,
	"./default-avatar.svg": 575,
	"./default-user.svg": 576,
	"./lines.png": 577,
	"./my-team-person-logo.jpg": 588,
	"./no-image.svg": 600,
	"./tdc_logo.png": 578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 538;